import {
  SectionElement,
  defineElement,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/shop-history/shop-history.ts
var ShopHistory = class extends SectionElement {
  connectedCallback() {
    const observer = new IntersectionObserver((entries, observer2) => {
      entries.forEach((entry) => {
        var _a;
        if (entry.isIntersecting) {
          const id = (_a = entry.target.querySelector("[data-history-hook]")) == null ? void 0 : _a.getAttribute("id");
          this.links.forEach((link) => {
            var _a2;
            link.classList.remove("!text-primary");
            if (link.children[0] !== void 0) {
              link.children[0].classList.remove("!block");
            }
            if (((_a2 = link.getAttribute("href")) == null ? void 0 : _a2.substring(1)) === id) {
              link.classList.add("!text-primary");
              if (link.children[0] !== void 0) {
                link.children[0].classList.add("!block");
              }
            }
          });
        }
      });
    }, { threshold: 0.8 });
    this.cards.forEach((card) => {
      observer.observe(card);
    });
  }
};
__decorateClass([
  queryAll("[data-history-card]")
], ShopHistory.prototype, "cards", 2);
__decorateClass([
  queryAll("[data-history-link]")
], ShopHistory.prototype, "links", 2);
ShopHistory = __decorateClass([
  defineElement("shop-history")
], ShopHistory);
export {
  ShopHistory
};
